export function update(idx, itemOrFn, collection) {
  const newItem = typeof itemOrFn === "function" ? itemOrFn(collection[idx], idx) : itemOrFn;
  return Object.assign([...collection], { [idx]: newItem });
}

export function insert(idx, item, collection) {
  return [...collection.slice(0, idx), item, ...collection.slice(idx)];
}

export function insertRange(idx, item, collection) {
  return [...collection.slice(0, idx), ...item, ...collection.slice(idx)];
}

export function remove(idx, collection) {
  return collection.filter((_, index) => index !== idx);
}

export function removeRange(indexes, collection) {
  if (!(indexes && indexes.length)) return collection;

  return collection.filter((_, index) => !indexes.includes(index));
}
